const GatewayStatus = {
  DISCONNECTED: "DISCONNECTED",
  CONNECTED: "CONNECTED",
  NOT_CONFIGURED: "NOT_CONFIGURED",
};

export default Object.freeze(GatewayStatus);
